import {
  IBusinessFacilityParams,
  ISuperAdminFacilityStatusDetails,
  ISuperAdminGetFacilityBookingCount
} from '../../_models/superAdmin/facilityInterface'
import { get, put } from './../apiServices'
/* eslint-disable camelcase */

export const getSuperAdminBusinessFacilities = async (params: IBusinessFacilityParams) => {
  const response = await get(`super-admin/business/${params.business_id}/facilities`, params)
  return response
}
export const updateSuperAdminFacilityStatus = async (facilityStatus: ISuperAdminFacilityStatusDetails) => {
  const response = await put('super-admin/facility/status', {
    facility_id: facilityStatus.facilityId,
    status: facilityStatus.status,
  })
  return response
}
export const getSuperAdminFacilityBookingCount = async (facilityDetails: ISuperAdminGetFacilityBookingCount) => {
  const response = await get('super-admin/facility/bookings/count', facilityDetails)
  return response
}
